export const checkboxFilterModels = [
    {
        name: "name",
        operator: "like",
        value: "",
        checked: true,
        displayName: "Trial Name",
        returnTrueOnEmpty: true,
    },
    {
        name: "speciesName",
        operator: "like",
        value: "",
        checked: false,
        displayName: "Species",
    },
    {
        name: "siteName",
        operator: "like",
        value: "",
        checked: false,
        displayName: "Site",
    },
    {
        name: "trialYear",
        operator: "like",
        value: "",
        checked: false,
        displayName: "Sowing Year",
    },
    {
        name: "regionName",
        operator: "like",
        value: "",
        checked: false,
        displayName: "Region",
    },
    {
        name: "trialVarieties",
        operator: "like",
        value: "",
        checked: false,
        displayName: "Variety / Cultivar",
    },
    // Rainfall
    {
        name: "annualRainfall",
        operator: "between",
        value: "",
        checked: false,
    },
    // SoilType
    {
        name: "soilTypeName",
        operator: "=",
        value: "",
        checked: false,
    },
    {
        name: "trialCode",
        operator: "like",
        value: "",
        checked: false,
        displayName: "Code",
    },
];
